import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import registration from './modules/registration'


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  chatInitialMessage: '',
  currency: localStorage.getItem('currency') || 'EUR',
  isAPILoading: false,
  isLoginModal: false,
  loginModalNotRedirect: false,
  isForgetPasswordModal: false,
  isGlobalErrorModal: false,
  isNewsletterSubscriberModal: false,
  newsletterSubscriberExpiry: localStorage.getItem('airspirit-newsletter-subscribers-modal-expiry') || null,
  isDonationModal: false,
  searchText: '',
}

const getters = {
  isAPILoading: state => !!state.isAPILoading,
  isForgetPasswordModal: state => !!state.isForgetPasswordModal,
  isLoginModal: state => !!state.isLoginModal,
  isNewsletterSubscriberModal: state => !!state.isNewsletterSubscriberModal,
  isDonationModal: state => !!state.isDonationModal,
}

const mutations = {
  closeForgetPasswordModal (state) {
    state.isForgetPasswordModal = false
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  setCurrency (state, currency) {
    state.currency = currency
    localStorage.setItem('currency', currency)
  },
  setExpiry (state, value) {
    console.log('setExpiry')
    state.newsletterSubscriberExpiry = value
    localStorage.setItem('airspirit-newsletter-subscribers-modal-expiry', value)
  },
  openForgetPasswordModal (state) {
    state.isForgetPasswordModal = true
  },
  openGlobalErrorModal (state) {
    state.isGlobalErrorModal = true
  },
  openLoginModal (state) {
    state.isLoginModal = true
  },
  openDonationModal (state) {
    state.isDonationModal = true
  },
  closeGlobalErrorModal (state) {
    state.isGlobalErrorModal = false
  },
  closeLoginModal (state) {
    state.isLoginModal = false
  },
  closeNewsletterSubscriberModal (state) {
    state.isNewsletterSubscriberModal = false
  },
  closeDonationModal (state) {
    state.isDonationModal = false
  },
  loadFromAPI (state) {
    state.isAPILoading = true
  },
  endLoadingFromAPI (state) {
    state.isAPILoading = false
  }
}


export default new Vuex.Store({
  modules: {
    user,
    auth,
    registration,
  },
  strict: debug,
  state,
  getters,
  mutations
})
